/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Search_Exercises_OfflineInputs */

const en_us2_search_exercises_offline = /** @type {(inputs: Search_Exercises_OfflineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No connection. Catalogue exercises show up when you are back online.`)
};

const pt_br2_search_exercises_offline = /** @type {(inputs: Search_Exercises_OfflineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sem conexão. Os exercícios do catálogo aparecem quando a internet voltar.`)
};

const es_419_search_exercises_offline = /** @type {(inputs: Search_Exercises_OfflineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sin conexión. Los ejercicios del catálogo aparecen cuando vuelva internet.`)
};

const pt_pt2_search_exercises_offline = /** @type {(inputs: Search_Exercises_OfflineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sem ligação. Os exercícios do catálogo aparecem quando a internet voltar.`)
};

const fr_fr2_search_exercises_offline = /** @type {(inputs: Search_Exercises_OfflineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pas de connexion. Les exercices du catalogue s'afficheront au retour d'internet.`)
};

const de_de2_search_exercises_offline = /** @type {(inputs: Search_Exercises_OfflineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Keine Verbindung. Katalogübungen erscheinen, sobald du wieder online bist.`)
};

const it_it2_search_exercises_offline = /** @type {(inputs: Search_Exercises_OfflineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nessuna connessione. Gli esercizi del catalogo compaiono quando torni online.`)
};

/**
* | output |
* | --- |
* | "No connection. Catalogue exercises show up when you are back online." |
*
* @param {Search_Exercises_OfflineInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const search_exercises_offline = /** @type {((inputs?: Search_Exercises_OfflineInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Search_Exercises_OfflineInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_search_exercises_offline(inputs)
	if (locale === "es-419") return es_419_search_exercises_offline(inputs)
	if (locale === "pt-PT") return pt_pt2_search_exercises_offline(inputs)
	if (locale === "fr-FR") return fr_fr2_search_exercises_offline(inputs)
	if (locale === "de-DE") return de_de2_search_exercises_offline(inputs)
	if (locale === "it-IT") return it_it2_search_exercises_offline(inputs)
	return en_us2_search_exercises_offline(inputs)
});
export { search_exercises_offline as "search.exercises_offline" }